import { render, staticRenderFns } from "./ProcesoCompraPlanoGeneral.vue?vue&type=template&id=b05308e0"
import script from "./ProcesoCompraPlanoGeneral.vue?vue&type=script&lang=js"
export * from "./ProcesoCompraPlanoGeneral.vue?vue&type=script&lang=js"
import style0 from "./ProcesoCompraPlanoGeneral.vue?vue&type=style&index=0&id=b05308e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports